export enum JobStatus {
    pending = 'Pending',
    success = 'Success',
    failed = 'Fail'
}
export enum ParameterType {
    DateTime = 'DateTime',
    Date = 'Date',
    Boolean = 'Boolean',
    MultiLine = 'Multiline',
    SingleLine = 'String',
    Integer = 'Integer',
    Enum = 'Enum'
}